import Lang from 'lang.js'
import messages from './messages'

export { default as withIntl } from './withIntl';

export default new Lang({ messages });